module.exports = __webpack_public_path__ + "static/img/icon-level-02.dfd93bb6.svg";